import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_PROFB1_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getProfB1ReferenceData = createAsyncThunk(
    'stop/getProfB1ReferenceData',
    async (params) => {
      const config = {
        headers: {
          Authorization: params,
          Region: STOP_REGION
        },
      };
      const response = await axios
        .get(EPISODE_PROFB1_REFERENCE_DATA_URL, config)
        .then((response) => {
          return response;
        })
        .catch((e) => {
          console.log(e);
          return e;
        });
      const data = await response.data.data;
      return data === undefined ? null : data;
    }
  );

  const profB1ReferenceDataSlice = createSlice({
    name: 'stop/profB1Reference',
    initialState: null,
    reducers: {
      resetProfB1Reference: () => null,
    },
    extraReducers: {
      [getProfB1ReferenceData.fulfilled]: (state, action) => action.payload,
    },
  });
  
  export const { resetProfB1Reference } = profB1ReferenceDataSlice.actions;
  
  export default profB1ReferenceDataSlice.reducer;